module.exports = __webpack_public_path__ + "static/media/TC.690c38db.svg";